
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_14iqq_1n311_98",
  "root-fit-height": "awsui_root-fit-height_14iqq_1n311_109",
  "variant-default": "awsui_variant-default_14iqq_1n311_115",
  "variant-stacked": "awsui_variant-stacked_14iqq_1n311_115",
  "header": "awsui_header_14iqq_1n311_138",
  "header-sticky-disabled": "awsui_header-sticky-disabled_14iqq_1n311_143",
  "header-sticky-enabled": "awsui_header-sticky-enabled_14iqq_1n311_147",
  "header-stuck": "awsui_header-stuck_14iqq_1n311_153",
  "header-dynamic-height": "awsui_header-dynamic-height_14iqq_1n311_158",
  "with-paddings": "awsui_with-paddings_14iqq_1n311_164",
  "with-hidden-content": "awsui_with-hidden-content_14iqq_1n311_167",
  "header-variant-cards": "awsui_header-variant-cards_14iqq_1n311_171",
  "header-variant-full-page": "awsui_header-variant-full-page_14iqq_1n311_195",
  "dark-header": "awsui_dark-header_14iqq_1n311_213",
  "content": "awsui_content_14iqq_1n311_217",
  "footer": "awsui_footer_14iqq_1n311_228",
  "with-divider": "awsui_with-divider_14iqq_1n311_231"
};
  